import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>You need to contact the prescriber. The prescriber will need to cancel this prior authorization and request a new prior authorization with the correct number of calories per day.</p>
			</div>
		);
	}
}